<template>
  <div>
    <div class="d-flex align-content-between align-items-start">
      <v-select 
        :value="value"
        :loading="loading" 
        class="flex-grow-1"
        :options="lab_types" 
        :close-on-select="true" 
        :reduce="val => val.id" 
        placeholder="Type"
        dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
        label="name"
        clearable 
        @input="onOptionSelected"
      >
      </v-select>
    </div>
  </div>
</template>
  
<script>
import { get } from 'lodash';

import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    vSelect,

  },
  props: {
    value: {
      default: "",
      type: String,
      required: false,
    }
  },
  data() {
    return {
      loading: false,
      toggleModal: false,

      lab_types: [{}],
      lab_type_ids: [],
    }
  },
  created() {
    this.fetchLabTypes();
  },
  methods: {
    async fetchLabTypes(category_id) {
      try {
        this.loading = true;

        const query = {
          page: 1,
          limit: 50,
          search: category_id || this.value,
        }
        
        const request = await this.useJwt().mainService.labTypes.list(query);
        const { data } = request.data;
        this.lab_types = data
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    onOptionSelected(val){
      this.$emit('change', val)
    },
  }
}
</script>
